function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.979,
    y: 24,
    style: {
      fill: "#E8F6FC"
    },
    width: 267,
    height: 415.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.479,
    y: 24,
    style: {
      fill: "#CEE2E9"
    },
    width: 131.5,
    height: 415.94
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212CBB"
    },
    d: "M289.479,0H67.521c-24.853,0-45,20.147-45,45v423.817c0,23.849,19.334,43.183,43.183,43.183h225.593   c23.849,0,43.183-19.334,43.183-43.183V45C334.479,20.147,314.332,0,289.479,0z M304.479,394.996   c0,14.89-12.239,27.003-27.283,27.003H79.762c-14.547,0-26.47-11.327-27.241-25.539V45c0-8.284,6.716-15,15-15h16.232   c3.117,0,5.883,1.866,7.195,4.693c6.812,14.681,21.686,24.89,38.906,24.89h97.251c17.221,0,32.095-10.209,38.906-24.89   c1.312-2.827,4.078-4.693,7.195-4.693h16.273c8.284,0,15,6.716,15,15V394.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00215A"
    },
    d: "M289.479,0h-111v59.583h48.625c17.221,0,32.095-10.209,38.906-24.89   c1.312-2.827,4.078-4.693,7.195-4.693h16.273c8.284,0,15,6.716,15,15v349.996c0,14.89-12.239,27.003-27.283,27.003h-98.717V512   h112.817c23.849,0,43.183-19.333,43.183-43.183V45C334.479,20.147,314.332,0,289.479,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E8F6FC"
    },
    d: "M178.5,482c8.262,0,15-6.739,15-15c0-8.262-6.738-15-15-15   c-8.262,0-15,6.738-15,15C163.5,475.261,170.238,482,178.5,482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00EED1"
    },
    d: "M459.479,365h-299c-16.542,0-30-13.458-30-30V147c0-16.542,13.458-30,30-30h299   c16.542,0,30,13.458,30,30v188C489.479,351.542,476.021,365,459.479,365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00CCB3"
    },
    d: "M459.479,117h-149.5v248h149.5c16.542,0,30-13.458,30-30V147   C489.479,130.458,476.021,117,459.479,117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#CEE2E9"
    },
    d: "M178.5,451.999c-0.007,0-0.014,0.001-0.021,0.001v29.999   c0.007,0,0.014,0.001,0.021,0.001c8.262,0,15-6.739,15-15C193.5,458.738,186.762,451.999,178.5,451.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0040A0"
    },
    d: "M213.479,232h-8c-8.284,0-15-6.716-15-15s6.716-15,15-15h8c8.284,0,15,6.716,15,15   S221.763,232,213.479,232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0040A0"
    },
    d: "M351.479,307.001h-146c-8.284,0-15-6.716-15-15s6.716-15,15-15h146c8.284,0,15,6.716,15,15   S359.763,307.001,351.479,307.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00215A"
    },
    d: "M351.479,277.001h-41.5v30h41.5c8.284,0,15-6.716,15-15S359.763,277.001,351.479,277.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0040A0"
    },
    d: "M281.479,232h-8c-8.284,0-15-6.716-15-15s6.716-15,15-15h8c8.284,0,15,6.716,15,15   S289.763,232,281.479,232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00215A"
    },
    d: "M349.479,232h-8c-8.284,0-15-6.716-15-15s6.716-15,15-15h8c8.284,0,15,6.716,15,15   S357.763,232,349.479,232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00215A"
    },
    d: "M417.479,232h-8c-8.284,0-15-6.716-15-15s6.716-15,15-15h8c8.284,0,15,6.716,15,15   S425.763,232,417.479,232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePayment);
export default __webpack_public_path__ + "static/media/mobile-payment.e7df489f17b287670c7cf4dd326b233a.svg";
export { ForwardRef as ReactComponent };